@import '../../../theme.scss';

verdocs-sign {
  display: flex;
  overflow: hidden;
  min-height: 700px;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
  font-family: $verdocs-primary-font;

  div {
    display: block;
    box-sizing: border-box;
  }

  input {
    vertical-align: top;
  }

  > .document {
    flex: 1;
    width: 100%;
    height: 100%;
    align-self: center;
    display: flex;
    padding: 15px;
    // We add extra padding here so the flags (which are absolutely positioned "outside" the page)
    // are still visible within the scrollable area.
    padding-right: 140px;
    row-gap: 15px;
    max-width: 1200px;
    min-height: 200px;
    position: relative;
    overflow-y: scroll;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;

    .inner {
      width: 100%;
      max-width: 1028px;
    }

    .document-separator {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 20px;
      width: 100%;
      max-width: 1028px; // Match standard page width + margins
      box-sizing: border-box;
      background-color: $verdocs-grey-1;
      color: white;
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      margin-top: 20px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      svg {
        flex-shrink: 0;
      }

      // Remove margin for the very first one if desired, but 20px spacing is probably good even for the first one
      &:first-child {
        margin-top: 0;
      }
    }
  }

  // Formerly inline styles, moved here for responsive control
  .signed-document-container {
    width: 64%;
    margin-left: 260px;
    transition: all 0.3s ease;

    &.zoom-normal {
      width: 64%;
      margin-left: 260px;
    }

    &.zoom-zoom1 {
      width: 80%;
      margin-left: 200px;
    }

    &.zoom-zoom2 {
      width: 100%;
      margin-left: 150px;

      .verdocs-flag-instance {
        opacity: 0;
        pointer-events: none;
      }
    }
  }

  @media (max-width: 768px) {
    verdocs-sign-footer {
      padding: 0 10px;

      .buttons {
        gap: 8px;

        button {
          font-size: 10px;
        }
      }
    }

    .signed-document-container {
      width: 100%;
      margin-left: 0;

      // Ensure specific zoom levels don't override the mobile layout
      &.zoom-normal,
      &.zoom-zoom1,
      &.zoom-zoom2 {
        width: 100%;
        margin-left: 0;
      }
    }

    > .document {
      padding-right: 15px;
    }

    // Hide flags on mobile
    .verdocs-flag-instance {
      display: none !important;
    }

    // Hide toolbars on mobile
    .controls-toolbar {
      .center-controls {
        display: none;
      }

      .right-controls {
        .mobile-next-button {
          display: block;
          margin-right: 10px;
        }

        .minus,
        .plus {
          display: none;
        }
      }
    }
  }

  .cover {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 5000;
    position: absolute;
    padding-top: 100px;
    align-items: center;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.5);
  }

  verdocs-ok-dialog .background-overlay {
    align-items: flex-start;
    padding-top: 100px;
  }

  .loading-indicator {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 10000;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .fatal-error {
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #4a4a4a;
    display: flex;
    align-items: center;
    justify-content: center;

    .placeholder {
      position: absolute;
      opacity: 0.1;
      z-index: -1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 612px;
      height: 792px;
      box-shadow: 0 0 10px 5px #0000000f;
      margin-top: 15px;
    }

    .message {
      max-width: 360px;
      width: 50%;
      font-size: 16px;
      background: white;
      box-shadow: 3px 3px 9px -1px #0000003f;
    }

    .header {
      color: white;
      font-size: 18px;
      font-weight: 500;
      padding: 5px 10px;
      margin: 0 0 10px 0;
      background: $verdocs-purple-shade;
    }

    p {
      margin: 1rem;
      font-size: 14px;
      font-weight: 400;
      padding: 0 10px;
    }
  }
}

@media print {
  verdocs-sign .header,
  .controls-toolbar,
  .verdocs-flag-instance,
  verdocs-signing-progress {
    display: none !important;
  }

  verdocs-sign {
    min-height: auto;
    background-color: white;

    > .document {
      overflow: visible;
      height: auto;
      display: block; // Flex can cause print issues
      padding: 0;
      margin: 0;

      .document-separator {
        display: none;
      }
    }

    .signed-document-container {
      width: 100%;
      margin: 0;
    }
  }
}

// Styled separately because this toolbar can be reparented
#verdocs-sign-header {
  color: #fff;
  width: 100%;
  display: flex;
  z-index: 1000;
  flex: 0 0 46px;
  font-size: 12px;
  column-gap: 15px;
  align-items: center;
  flex-direction: row;
  transition: all 0.25s;
  background-color: $medium-bg;
  box-shadow:
    0 4px 4px 0 rgb(0 0 0 / 24%),
    0 0 4px 0 rgb(0 0 0 / 12%);

  .inner {
    width: 100%;
    display: flex;
    margin: 0 auto;
    padding: 0 12px;
    max-width: 1200px;
    align-items: center;
    flex-direction: row;
    column-gap: 10px;
  }

  .logo {
    width: 80px;
    display: none;
    margin: -6px 0 0 0;
  }

  .title {
    font-size: 18px;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 10px 0 0;
    text-overflow: ellipsis;

    @media(max-width: $screen-mobile-lg){
      font-size: 14px;
    }
  }

  .remaining-count {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;

    .check-icon {
      display: inline-flex;
      align-items: center;

      svg {
        width: 16px;
        height: 16px;
        fill: $verdocs-green;
      }
    }

    .separator {
      opacity: 0.5;
      margin: 0 2px;
    }

    .review-optional {
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: $verdocs-green-highlight;
      }

      @media(max-width: $screen-mobile-lg){
        display: none;
      }
    }

    @media(max-width: $screen-mobile-lg){
      font-size: 12px;
    }
  }

  .icon-button {
    width: 20px;
    height: 32px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s;

    svg path {
      fill: #ffffff;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    &.disabled {
      opacity: 0.35;
      pointer-events: none;
    }

    // Tighten the spacing between adjacent icon buttons (e.g. the zoom in/out pair).
    // .inner has a 10px column-gap; pulling adjacent icons closer gives a grouped feel.
    & + .icon-button {
      margin-left: -6px;
    }

    &.magnify {
      @media(max-width: $screen-mobile-lg){
        display: none
      }
    }
  }
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  background: #0000007f;
  justify-content: center;
}

.controls-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  // 24px by design but the design had the right-most icon flush against the edge.
  // Since we have extra padding on the icons to make them more clickable, we need
  // to reduce the right padding here.
  padding: 0 12px 0 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: none;
  font-family: 'Inter', sans-serif;
  color: #424242;
  z-index: 1000;

  .left-controls {
    flex: 1;
    display: flex;
    align-items: center;

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #242424;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .center-controls {
    flex: 1;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
    display: none; // Temporary hide

    .label {
      color: #000000;
      font-weight: 300;
    }

    .select-wrapper {
      // Wrapper styles from before were mainly for the native select arrow logic.
      // With verdocs-select-input, we might not need as much here, but let's keep it clean.
      display: flex;
      align-items: center;

      verdocs-select-input {
        margin: 0;

        // Hide the label block inside the component
        .input-label {
          display: none;
        }

        .input-element {
          background: transparent;
          border: 1px solid #e0e0e0;
          height: 32px; // Match button height
          padding: 2px 8px;
          min-width: 60px;
          text-align: center;
          font-family: inherit;
          color: #424242;

          &:focus {
            border-color: var(--verdocs-primary-color, #{$verdocs-green});
          }
        }
      }
    }

    .count {
      color: #000000;
      font-weight: 300;
    }
  }

  .right-controls {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // NOTE: This is the expected gap, but we built it into additional padding in the icons
    // to make them more clickable.
    // gap: 12px;

    .mobile-next-button {
      display: none;
    }

    .icon-button {
      width: 32px;
      height: 32px;
      display: flex;
      color: #424242;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;

      &:hover {
        background-color: #f5f5f5;
      }

      &.disabled {
        opacity: 0.3;
        pointer-events: none;
      }

      svg {
        display: block;
        width: 20px;
        height: 20px;
      }
    }
  }
}
